var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWcf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 768.4 250",
    style: {
      enableBackground: "new 0 0 768.4 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#214f77}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m0 4.7 27 239.8h57.6l57.6-132.8 13 132.8h59.9L319.7 4.7H268l-59.9 138.7-13-138.7h-59.9L81.1 143.4 68.2 4.7zM597.6 4.7h170.8L759 59.6H657.9l-7 39.9h77.5l-10.9 51.8h-77.6l-15.7 93.2h-71.3zM472.2 99.5h68.2S554.5 0 460.5 0 319.7 79.2 319.7 156s56 94 96.8 94 99.6-24.3 112.1-93.3h-61.9s-11 36.1-43.1 36.1-32.1-44.7-23.5-76.8 29-65.8 53.3-61.9 21.9 31.3 18.8 45.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcf);
export default __webpack_public_path__ + "static/media/wcf.6538fdd7478f54ef5ea822ea340cc46c.svg";
export { ForwardRef as ReactComponent };